module.exports = __webpack_public_path__ + "img/minicode.c26821c6.png";